module.exports = __webpack_public_path__ + "static/media/33025233690_cfde759a95_o.97476693.jpg";